<template>
    <lv-column-text
                    :align="align"
                    :link="link"
                    :row="showRow"
                    :row-index="rowIndex"
                    :field="field"
                    :editable="lv_editable"
                    :data-type="dataType"
                    :tooltip="tooltip">
        <slot :row="row" :rowIndex="rowIndex" :align="align" :field="field" :editable="lv_editable">
            <link-img
                v-if="!fixedRow"
                class="link-table-column-image-item"
                :disabled="!lv_editable"
                :row="showRow"
                :head-id="!!autoSetHeadId&&!!showRow?showRow.id:null"
                :module-type="moduleType"
                :id-key="idKey"
                :big-url-key="bigUrlKey"
                :small-url-key="smallUrlKey"
                :shape="shape"
                :width="width"
                :height="height"
                :no-preview="noPreview"
                :customUpload="customUpload"
				@upload-success="val=>$emit('upload-success', val)"
            />
        </slot>
    </lv-column-text>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LinkInput from "../../input/link-input";
    import LinkImg from "../../img/link-img";
    import LvColumnText from "../lv-column-text";

    export default {
        name: "link-table-column-image-item",
        components: {LvColumnText, LinkImg, LinkInput},
        mixins: [ColumnItemMixin],
        props: {
            autoSetHeadId: {type: Boolean, default: true},  //是否自动设置headId
            moduleType: {},                                 //图片的模块

            idKey: {type: String, required: true},          //图片id存放的id
            bigUrlKey: {type: String,},                     //图片大图key
            smallUrlKey: {type: String, required: true},    //图片小图key
            width: {type: Number, default: 50},            // 每张图片显示宽度
            height: {type: Number, default: 50},           // 每张图片显示高度

            shape: {type: String, default: 'round', validator: val => LinkUtils.oneOf(val, ['fillet', 'none', 'round'])},                              // 设定弹出框的圆角（fillet）方角（none）圆形（round）
            noPreview: {type: Boolean},                     //是否禁用点击图片放大显示
            customUpload: {type: Function},                 //自定义获取图片的函数
        },
    }
</script>

<style lang="scss">
    .link-table-column-image-item {

    }
</style>
